__turbopack_context__.v({
  "explore-wrap": "section-title-module-scss-module__rki4WW__explore-wrap",
  "explore-wrap-link": "section-title-module-scss-module__rki4WW__explore-wrap-link",
  "header": "section-title-module-scss-module__rki4WW__header",
  "header-title": "section-title-module-scss-module__rki4WW__header-title",
  "section-icon": "section-title-module-scss-module__rki4WW__section-icon",
  "summary": "section-title-module-scss-module__rki4WW__summary",
});
